import { render, staticRenderFns } from "./matchingResult.vue?vue&type=template&id=1af12f7b&scoped=true"
import script from "./matchingResult.vue?vue&type=script&lang=js"
export * from "./matchingResult.vue?vue&type=script&lang=js"
import style0 from "./matchingResult.vue?vue&type=style&index=0&id=1af12f7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af12f7b",
  null
  
)

export default component.exports